const en = {
  tagline: 'ONE CORE. INFINITE BUILDS.',
  play: 'START RUN',
  endgame: 'ENDGAME TEST',
  playAgain: 'PLAY AGAIN',
  workshop: 'WORKSHOP',
  settings: 'SETTINGS',
  home: 'HOME',
  continue: 'CONTINUE',
  skip: 'SKIP & CONTINUE',
  reroll: 'REROLL',
  resume: 'RESUME',
  pause: 'PAUSE',
  abandon: 'ABANDON RUN',
  coreCoins: 'CORE COINS',
  blueprintLocked: 'GRAVITY MATRIX: UNKNOWN',
  blueprintUnlocked: 'GRAVITY MATRIX: ONLINE',
  upgradeTitle: 'CORE LEVEL INCREASED',
  upgradeSubtitle: 'Choose one system upgrade',
  shopTitle: 'WAVE CLEARED',
  shopSubtitle: 'Spend combat cash on one permanent run stat',
  evolutionTitle: 'EVOLUTION ONLINE',
  victoryTitle: 'SECTOR CLEARED',
  defeatTitle: 'CORE DESTROYED',
  reward: 'RUN REWARD',
  blueprintAcquired: 'NEW BLUEPRINT: GRAVITY MATRIX',
  max: 'MAX',
  purchase: 'UPGRADE',
  insufficient: 'INSUFFICIENT COINS',
  power: 'POWER',
  powerDescription: '+2% starting damage per level',
  integrity: 'INTEGRITY',
  integrityDescription: '+2% starting Core HP per level',
  insight: 'INSIGHT',
  insightDescription: '+2% XP gain per level',
  graphics: 'GRAPHICS QUALITY',
  damageNumbers: 'DAMAGE NUMBERS',
  reducedShake: 'REDUCED SCREEN SHAKE',
  reducedFlashes: 'REDUCED FLASHES',
  haptics: 'HAPTICS',
  muted: 'MUTE AUDIO',
  textScale: 'TEXT SCALE',
  back: 'BACK',
  debug: 'DEBUG',
} as const;

export type TranslationKey = keyof typeof en;

export function t(key: TranslationKey): string {
  return en[key];
}
